import { WorkInterventionDaysRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: [],
    item: {}
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
    item (state, data) {
      state.item = {}
      state.item = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionDaysRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    get ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionDaysRepository.get(obj)
          .then(response => {
            const data = response.data.data
            commit('item', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionDaysRepository.create(obj)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, obj) {      
      return new Promise((resolve, reject) => {
        WorkInterventionDaysRepository.update(obj)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionDaysRepository.delete(obj)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
